import { panel, focus } from "../../UI/tokens";
import styled from 'styled-components';
import { v } from '../../../styles/variables';

export const StepContainer = styled.div`
  display: flex;
  justify-content: center;
  cursor: pointer;
  position: relative;
  width: auto;
  padding: 1lvh 0;

padding: 4px; ${focus}
`;

export const StepContent = styled.div`
  padding: 10px 18px; border-radius: 8px; font-size: 13px; font-weight: 600;
  background-color: ${({ active, completed, exist }) => active ? '#315cbe' : completed ? '#237453' : exist ? '#61558c' : '#596579'};
  color: #fff; white-space: normal; text-align: center;

`;

export const StepActive = styled.div`
${panel}
 width: 100%; padding: 20px; margin-top: 16px;
`;
